export const DYNAMIC_PROFILING_GENERAL_PHRASES = {
    PLEASE_SELECT: 345,
    SELECTION_COMMENT: 4696,
    SUBMIT: 1972,
    EMPTY_QUESTIONS: 3790,
    MAIN_TITLE: 15965,
};

export const DYNAMIC_PROFILING_INTRO_PHRASES = {
    // from current site(having M3 in naming)
    WELCOME_TITLE: 3792,
    WELCOME_TEXT: 3793,
    BENEFITS_TITLE: 3794,
    BENEFIT1_TEXT: 3795,
    BENEFIT2_TEXT: 3796,
    BENEFIT3_TEXT: 3797,
    BENEFIT4_TEXT: 3798,
    AGREEMENT_TITLE: 3748,
    AGREEMENT_CHECKBOX_TEXT: 3749,
    AGREEMENT_CHECKBOX_REQUIRED_ERROR: 16081,
    SUBMIT_BUTTON: 1972,
};

export const DYNAMIC_PROFILING_QUESTION_PHRASES = {
    //unknown (for test purposes)
    QUESTION_1: 90009001,
    QUESTION_2: 90009002,
    QUESTION_3: 90009003,
    QUESTION_4: 90009004,
    ANSWER_1: 90005501,
    ANSWER_2: 90005502,
    ANSWER_3: 90005503,
    ANSWER_4: 90005504,
    ANSWER_5: 90005505,
    SYMBOL: 90009299,
    TEST_ERROR_1: 90009022,
    TEST_ERROR_2: 90009023,
    QUESTION_DESCRIPTION: 900900112,
};

export const DYNAMIC_PROFILING_CONTROL_PHRASES = {
    CONTROL_LINK: 3791,

    //unknown (used existed ones but they are contains M3)
    MAIN_TITLE: 3781,
    CONTROL_DATA_TEXT: 3782,
    DOWNLOAD_DATA_BUTTON: 3783,
    WITHDRAW_CONFIRMATION_TITLE: 3787,
    WITHDRAW_CONFIRMATION_TEXT: 3788,
    WITHDRAW_SUCCESS_TEXT: 3799,
    WITHDRAW_TEXT: 3784,
    WITHDRAW_BUTTON: 3785,
    BACK_TO_PROFILE: 3786,

    //unknown
    WITHDRAW_CONFIRM_BUTTON: 3478,
    WITHDRAW_CANCEL_BUTTON: 189,
};
